/*
 * @Author: Teemo Ding
 * @Date: 2021-08-25 09:36:06
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-27 14:46:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDatabaseSettings/AdvancedInputFieldValidation/index.tsx
 */
import { Input } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const AdvancedInputFieldValidation = ({ disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.fullNameAutoPopulate}
        title={getI18n(
          'customerDatabaseSetting.advancedInputFieldValidation.field_validation',
        )}>
        <Form.Item
          className={css.fullNameAutoPopulateItem}
          label={getI18n(
            'customerDatabaseSetting.advancedInputFieldValidation.advanced_valid',
          )}
          name='customerNameValidationRegex'
          labelCol={{ span: '24' }}>
          <Input
            size='large'
            placeholder='/ [ \x00-\xFF ] /'
            disabled={disabled}
          />
        </Form.Item>
      </SectionWrapper>
    </div>
  );
};

export default AdvancedInputFieldValidation;
